 document.addEventListener('DOMContentLoaded', function() {
           function checktabs(){
                 // 缓存Tabs容器
             var tabContainers = document.querySelector('#jsTabsContainer');
             if (tabContainers) {
                                   
                return true;
             }
             return false;
           }
            if(!checktabs()){
                 // 按钮还没渲染，用 MutationObserver 等待
                 var observer = new MutationObserver(function () {
                 if (checktabs()()) observer.disconnect();
                });
                observer.observe(document.body, { childList: true, subtree: true });
            }else{
                var tabContainers = document.querySelector('#jsTabsContainer');
                // 获取数据源
                        var sourceSelector = tabContainers.getAttribute('data-source');
                        var sourceElement = document.querySelector(sourceSelector);
                        
                        if (!sourceElement) return;
                        
                        // 获取所有h3元素作为标签页标题
                        var h3Elements = sourceElement.querySelectorAll('h1');
                        
                        if (h3Elements.length === 0) {
                            // 如果没有h3标签，创建默认的"Description"标签
                            createDefaultTab(tabContainers, sourceElement);
                        } else {
                            // 有h3标签，创建多标签页
                            createMultipleTabs(tabContainers, sourceElement, h3Elements);
                        }
                       // 初始化所有标签页
                initTabs();
            }
           
            
          
           
            
            /**
             * 创建默认标签页（没有h3标签的情况）
             * @param {HTMLElement} tabContainer - 标签页容器
             * @param {HTMLElement} sourceElement - 数据源元素
             */
            function createDefaultTab(tabContainer, sourceElement) {
                // 创建选项卡菜单
                var tabsMenu = document.createElement('ul');
                tabsMenu.className = 'tabs';
                tabContainer.appendChild(tabsMenu);
                
                // 创建默认标签页按钮
                var listItem = document.createElement('li');
                var link = document.createElement('a');
                link.href = '#tab-default';
                link.textContent = 'Description';
                link.setAttribute('data-tab', 'tab-default');
                listItem.appendChild(link);
                tabsMenu.appendChild(listItem);
                
                // 创建标签页内容容器，包含所有内容
                var tabPane = document.createElement('div');
                tabPane.id = 'tab-default';
                tabPane.className = 'tab-content';
                
                // 复制数据源的所有内容（不包括自身，只包括子元素）
                var contentHTML = '';
                var children = sourceElement.children;
                for (var i = 0; i < children.length; i++) {
                    contentHTML += children[i].outerHTML;
                }
                tabPane.innerHTML = contentHTML;
                
                tabContainer.appendChild(tabPane);
            }
            
            /**
             * 创建多标签页（有h3标签的情况）
             * @param {HTMLElement} tabContainer - 标签页容器
             * @param {HTMLElement} sourceElement - 数据源元素
             * @param {NodeList} h3Elements - h3元素集合
             */
            function createMultipleTabs(tabContainer, sourceElement, h3Elements) {
                // 创建选项卡菜单
                var tabsMenu = document.createElement('ul');
                tabsMenu.className = 'tabs';
                tabContainer.appendChild(tabsMenu);
                
                h3Elements.forEach(function(h3, index) {
                    // 创建标签页按钮
                    var title = h3.textContent;
                    var listItem = document.createElement('li');
                    var link = document.createElement('a');
                    link.href = '#tab' + index;
                    link.textContent = title;
                    link.setAttribute('data-tab', 'tab' + index);
                    listItem.appendChild(link);
                    tabsMenu.appendChild(listItem);
                    
                    // 获取标签页内容
                    var tabContent = [];
                    var currentElement = h3.nextElementSibling;
                    var i = 0;
                    
                    while (i < 100 && currentElement) {
                        i++;
                        
                        // 如果下一个元素不是h1，则添加到内容中
                        if (currentElement.tagName !== 'h1') {
                            tabContent.push(currentElement.outerHTML);
                            currentElement = currentElement.nextElementSibling;
                            continue;
                        }
                        break;
                    }
                    
                    // 创建标签页内容容器
                    var tabPane = document.createElement('div');
                    tabPane.id = 'tab' + index;
                    tabPane.className = 'tab-content';
                    
                    if (tabContent.length > 0) {
                        tabPane.innerHTML = tabContent.join('');
                    } else {
                        tabPane.innerHTML = '<p>No content available for this tab.</p>';
                    }
                    
                    tabContainer.appendChild(tabPane);
                });
            }
            
            /**
             * 初始化所有标签页功能
             */
            function initTabs() {
                var tabsContainers = document.querySelectorAll('#jsTabsContainer ul.tabs');
                
               tabsContainers.forEach(function(tabsList) {
                    var links = tabsList.querySelectorAll('a');
                    
                    if (links.length === 0) return;
                    
                    // 默认显示第一个标签页
                    var firstLink = links[0];
                    var firstTabId = firstLink.getAttribute('data-tab') || 
                                    firstLink.getAttribute('href').substring(1);
                    
                    firstLink.classList.add('active');
                    var firstTabContent = document.getElementById(firstTabId);
                    if (firstTabContent) {
                        firstTabContent.classList.add('active');
                    }
                    
                    // 隐藏其他标签页内容
                    Array.from(links).forEach(function(link, index) {
                        if (index > 0) {
                            var tabId = link.getAttribute('data-tab') || 
                                      link.getAttribute('href').substring(1);
                            var tabContent = document.getElementById(tabId);
                            if (tabContent) {
                                tabContent.classList.remove('active');
                            }
                        }
                    });
                    
                    // 为每个标签页链接添加点击事件
                    tabsList.addEventListener('click', function(e) {
                        var target = e.target;
                        
                        // 确保点击的是链接
                        if (target.tagName !== 'A') {
                            var parentLink = target.closest('a');
                            if (parentLink) {
                                target = parentLink;
                            } else {
                                return;
                            }
                        }
                        
                        e.preventDefault();
                        
                        // 获取当前激活的标签页
                        var activeLink = tabsList.querySelector('a.active');
                        if (activeLink) {
                            var activeTabId = activeLink.getAttribute('data-tab') || 
                                            activeLink.getAttribute('href').substring(1);
                            var activeContent = document.getElementById(activeTabId);
                            
                            if (activeContent) {
                                activeContent.classList.remove('active');
                            }
                            activeLink.classList.remove('active');
                        }
                        
                        // 激活点击的标签页
                        var tabId = target.getAttribute('data-tab') || 
                                  target.getAttribute('href').substring(1);
                        var content = document.getElementById(tabId);
                        
                        if (content) {
                            content.classList.add('active');
                            target.classList.add('active');
                        }
                    });
                });
            }
        });